import { Component, OnInit } from '@angular/core';
import { NgForm } from "@angular/forms";
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from "../../login/shared/auth.service";
import { Confirmpasswordvalidator } from "../Shared/confirmpasswordvalidator";
import { UsermanagementService } from "../Shared/usermanagement.service";

import { ToasterserviceService } from "../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../utility/shared/toastpayload";

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent implements OnInit {

  ChangePasswordForm: FormGroup;
  AddButtonText: string;
  submitted: boolean = false;
  toast: Toastpayload;

  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute,
    private usermanagementService: UsermanagementService,
    private toasterserviceService: ToasterserviceService,
    private router: Router) {
    this.AddButtonText = "Save";
  }

  ngOnInit() {

    this.ChangePasswordForm = this.formBuilder.group({
      EmployeeId: [JSON.parse(localStorage.getItem("EmployeeData"))["Id"]],
      OldPassword: ['', [Validators.required]],
      Password: ['', [Validators.required, Validators.minLength(6)]],
      ConfirmPassword: ['', [Validators.required, Validators.minLength(6)]],
      IsRoleManagement: 0,
      Flag: 5,
    },
      {
        validator: Confirmpasswordvalidator("Password", "ConfirmPassword")
      }
    );

    // this.userForm = this.fb.group({
    //   firstName: this.fb.control<string>('', [Validators.required]),
    //   lastName: this.fb.control<string>('', [Validators.required]),
    //   age: this.fb.control<number>(0, [Validators.required]),
    // });

    // reference:
    // https://stackblitz.com/edit/angular-match-password-validation?file=src%2Fapp%2Fapp.component.html
    // https://www.scaler.com/topics/angular/reactive-forms-in-angular/
  }

  onSubmit(form: NgForm) {
    this.submitted = true;
    // console.log(form.value.OldPassword);
    // console.log(this.ChangePasswordForm.value.NewPassword);

    this.toast = {
      message: "No Message Now!",
      title: 'Password change',
      ic: {
        timeOut: 2000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };

    this.usermanagementService.IUDUser(form.value)
      .toPromise()
      .then(data => {

        if (data[0].UniqueId == 5500) {
          this.toast.message = data[0].ResponseMessage;
          this.toast.type = 'error';
          this.toasterserviceService.showToast(this.toast);
        }
        else {
          this.toast.message = data[0].ResponseMessage;
          this.toast.type = 'success';
          this.toasterserviceService.showToast(this.toast);

          this.router.navigate(['/dashboard']);
        }
      })
  }

}
